import { render, staticRenderFns } from "./dkim-integration-widget.vue?vue&type=template&id=3cf6a661&"
import script from "./dkim-integration-widget.vue?vue&type=script&lang=js&"
export * from "./dkim-integration-widget.vue?vue&type=script&lang=js&"
import style0 from "./dkim-integration-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports